<template>
  <!-- Side Navbar -->
  <nav id="sidebar" class="navbar-dark bg-indigo" :class="{'active': !navbarCollapsed}">
      <div class="d-flex flex-column" style="height: calc(100vh - 15px)">
        <div id="brand_hover" class="text-nowrap px-2 bg-indigo">
          <button class="btn bg-transparent mt-1 px-2 d-inline-block align-top mx-auto" data-toggle="tooltip" :data-original-title="navbarCollapsed ? 'Expand Menu Bar' : 'Collapse Menu Bar'" @click="toggleSidebar(true)">
            <span class="navbar-toggler-icon"></span>
          </button>
          <button v-if="false" class="btn-logo mt-1 px-2 d-inline-block align-top mr-1" data-toggle="tooltip" :data-original-title="navbarCollapsed ? 'Expand Menu Bar' : 'Collapse Menu Bar'" @click="toggleSidebar(true)">
            
          </button>
          <a href="/" class="navbar-brand mt-1 show-active ml-2">
              <span v-html="'&nbsp;'"></span>
          </a>
        </div>
        <div>
          <ul
            v-cloak
            class="navbar-nav mt-2" style="margin: auto 0; width: 100%;">
            
            <li v-if="activeView!='detail'" class="nav-item text-nowrap" :class="{'active': activeView == 'search'}">
              <router-link to="/search" class="nav-link"><svg class="svg-icon" data-toggle="tooltip" title="Search Message History"viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g id="_11_-_20" data-name="11 - 20"><g id="Research"><path d="m34 14a5.006 5.006 0 0 1 -5-5v-7h-17a5 5 0 0 0 -5 5v34a5 5 0 0 0 5 5h20a10 10 0 1 1 9-14.337v-17.663zm-20-3h11a1 1 0 0 1 0 2h-11a1 1 0 0 1 0-2zm5 28h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zm-6-6a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 -1-1zm7-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm14-5h-20a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2zm0-5h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2z"/><path d="m40.414 11.414-8.828-8.828a1.988 1.988 0 0 0 -.586-.4v6.814a3 3 0 0 0 3 3h6.814a1.988 1.988 0 0 0 -.4-.586z"/><path d="m43.31 44.49-4.424-4.432a8.02 8.02 0 1 0 -2.828 2.828l4.432 4.424a1.994 1.994 0 1 0 2.82-2.82zm-16.31-8.49a5 5 0 1 1 5 5 5 5 0 0 1 -5-5z"/></g></g></svg> <span class="ml-1 show-active">Records Search</span></router-link>
            </li>
            <li v-if="privs.CL" class="nav-item text-nowrap" :class="{'active': activeView == 'lookup'}">
              <router-link to="/lookup" class="nav-link"><svg class="svg-icon" data-toggle="tooltip" title="Review Subscriber Status" enable-background="new 0 0 512 512" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="m136 296c-24.813 0-45 20.187-45 45v15h90v-15c0-24.813-20.187-45-45-45z"/><circle cx="136.5" cy="250.5" r="15.5"/><path d="m0 166v225c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45v-225zm211 205c0 8.284-6.716 15-15 15h-120c-8.284 0-15-6.716-15-15v-30c0-27.816 15.233-52.126 37.784-65.074-20.212-29.885 1.145-70.926 37.716-70.926 25.089 0 45.5 20.411 45.5 45.5 0 9.59-2.99 18.49-8.075 25.834 22.161 13.048 37.075 37.141 37.075 64.666zm105 0h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15zm120 1h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-61h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-61h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z"/><path d="m512 136v-15c0-24.813-20.187-45-45-45h-422c-24.813 0-45 20.187-45 45v15z"/></g></svg> <span class="ml-1 show-active">Subscriber Lookup</span></router-link>
            </li>
            <li v-if="privs.SP" class="nav-item text-nowrap" :class="{'active': activeView == 'personas'}">
              <router-link to="/personas" class="nav-link"><svg class="svg-icon" data-toggle="tooltip" title="Explore Personas" enable-background="new 0 0 512 512" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m126.38 153.485c56.543 0 102.38 45.837 102.38 102.38 0 25.163-9.084 48.201-24.143 66.027-11.117-32.53-41.941-55.924-78.237-55.924-36.287 0-67.113 23.4-78.237 55.924-15.059-17.825-24.143-40.863-24.143-66.027 0-56.542 45.838-102.38 102.38-102.38zm251.995 325.89c-4.418 0-8-3.582-8-8s3.582-8 8-8h85.5c4.418 0 8 3.582 8 8s-3.582 8-8 8zm0-430.75c-4.418 0-8-3.582-8-8s3.582-8 8-8h85.5c4.418 0 8 3.582 8 8s-3.582 8-8 8zm0 107.688c-4.418 0-8-3.582-8-8s3.582-8 8-8h85.5c4.418 0 8 3.582 8 8s-3.582 8-8 8zm0 107.687c-4.418 0-8-3.582-8-8s3.582-8 8-8h85.5c4.418 0 8 3.582 8 8s-3.582 8-8 8zm0 107.688c-4.418 0-8-3.582-8-8s3.582-8 8-8h85.5c4.418 0 8 3.582 8 8s-3.582 8-8 8zm-31.359 67.062c-4.821 0-8.765 3.944-8.765 8.765v47.72c0 4.821 3.944 8.765 8.765 8.765h148.219c4.821 0 8.765-3.944 8.765-8.765v-47.72c0-4.821-3.944-8.765-8.765-8.765zm-208.078-49.093v73.718h183.313v16h-191.313c-4.418 0-8-3.582-8-8v-81.173c1.144.029 2.292.044 3.443.044 4.235 0 8.421-.206 12.557-.589zm183.313-17.969h-93.939c-2.23 0-4.247-.913-5.698-2.385l-10.207-10.207c4.102-3.421 7.996-7.083 11.662-10.963l7.555 7.555h90.626v16zm0-107.688h-61.742c.161-2.692.252-5.402.252-8.135 0-2.641-.085-5.262-.235-7.865h61.725zm0-107.687v-16h-93.939c-3.4 0-6.304 2.121-7.462 5.113l-5.027 10.16c4.189 3.739 8.146 7.734 11.839 11.966l5.557-11.239zm-199.313-34.784v-80.904c0-4.418 3.582-8 8-8h191.313v16h-183.313v73.449c-4.135-.383-8.322-.589-12.557-.589-1.151 0-2.299.015-3.443.044zm224.078 209.534c-4.821 0-8.765 3.944-8.765 8.765v47.72c0 4.821 3.944 8.765 8.765 8.765h148.219c4.821 0 8.765-3.944 8.765-8.765v-47.72c0-4.821-3.944-8.765-8.765-8.765zm0-107.687c-4.821 0-8.765 3.944-8.765 8.765v47.719c0 4.821 3.944 8.765 8.765 8.765h148.219c4.821 0 8.765-3.944 8.765-8.765v-47.719c0-4.821-3.944-8.765-8.765-8.765zm0-107.688c-4.821 0-8.765 3.944-8.765 8.765v47.72c0 4.821 3.944 8.765 8.765 8.765h148.219c4.821 0 8.765-3.944 8.765-8.765v-47.72c0-4.821-3.944-8.765-8.765-8.765zm0-107.688c-4.821 0-8.765 3.944-8.765 8.765v47.719c0 4.821 3.944 8.765 8.765 8.765h148.219c4.821 0 8.765-3.944 8.765-8.765v-47.719c0-4.821-3.944-8.765-8.765-8.765zm-220.635 169.438c-23.084 0-41.797 18.713-41.797 41.797s18.713 41.797 41.797 41.797 41.797-18.713 41.797-41.797c0-23.083-18.713-41.797-41.797-41.797zm-.001-39.953c-65.38 0-118.38 53-118.38 118.38s53.001 118.38 118.38 118.38 118.38-53 118.38-118.38c.001-65.379-53-118.38-118.38-118.38z" fill-rule="evenodd"/></svg> <span class="ml-1 show-active">Personas</span></router-link>
            </li>

          </ul>
        </div>
        <div class="mt-auto">
          <ul
          v-cloak
          class="navbar-nav mt-3" style="margin: auto 0; width: 100%;">
            <li v-if="activeView!='detail'" class="nav-item text-nowrap">
              <a href="/api/v1/logout" class="nav-link"><span class="glyphicons glyphicons-exit mr-1" style="font-size: 1.2em" data-toggle="tooltip" title="Log Out"></span>  <span class="ml-1 show-active">Log Out</span></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  <!-- /Main Site Navbar -->
  <!-- Persona Navbar -->
</template>

<script>
import {mapState} from 'vuex'

export default {
  components: {
  },
  props: {
    showSubAccounts: {
      type: Boolean,
      default: true
    },
    isMain:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showV2: true
    }
  },
  mounted: function() {
    
  },
  watch: {},
  computed: {
    ...mapState({
      activeView: (state)=>state.ui.activeView,
      privs: (state)=>state.user.privs,
      uiConfig: (state)=>{
        if (state.admin ) return state.admin.uiConfig;
        else return state.user.uiConfig;
      },
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      navbarCollapsed: (state)=>state.ui.navbarCollapsed,
      userInfo: (state)=>state.user.userInfo,
    }),
    subAccounts: function(){
      return this.uiConfig.sub_accounts;
    },
    activeSubAccountDisplayName: function() {
      return (this.activeSubAccount)? this.activeSubAccount.sub_account_display_name : 'All sources';
    },
    allowPersonas: function() {
      return (this.privs && this.privs.SP && this.uiConfig.account 
        && !this.uiConfig.account.config.personas_disabled);
    },
  },
  created: function() {
    if (localStorage.getItem("navBarExpanded")) {
      this.$store.commit("setNavbarCollapse",false);
    } else {
      this.$store.commit("setNavbarCollapse",true);
    }
  },
  mounted: function() {
    $('#sidebar').tooltip({selector: '[data-toggle="tooltip"]', html:true, trigger: 'hover', delay: { "show": 500, "hide": 100 }});

  },
  methods: {
    toggleSidebar() {
      let collapsed = !this.navbarCollapsed
      this.$store.commit("toggleNavbarCollapse");
      this.$eventBus.$emit("sideBarToggled",{collapsed: collapsed});
      if (collapsed) {
        localStorage.removeItem("navBarExpanded")
      } else {
        localStorage.setItem("navBarExpanded",true)
      }
    }
  },
}
</script>

<style scoped>

.bg-midnight {
  background-color: #1c2350;
}

#sidebar {
  width: 60px;
  height: 100vh;
  transition: width 0.3s;
}

#sidebar .show-active {
  display: none;
}

#sidebar.active .show-active {
  display: inline-block;
}

#sidebar.active .hide-active {
  display: none;
}

#sidebar.active {
  width: 250px;
}

#sidebar.active .svg-icon {
  width: 22px;
  height: 22px;
}

.logo-svg {
  width: 44px;
  height: 44px;
}

#sidebar .svg-icon {
  width: 22px;
  height: 22px;
}

.nav-item a .svg-icon {
  fill:  rgba(255, 255, 255, 0.75);
  transition: fill 0.2s;
}

#sidebar.navbar-dark .navbar-nav .nav-link {
  color:  rgba(255, 255, 255, 0.75);
}

.nav-item a:hover .svg-icon, .nav-item.active a .svg-icon {
  fill:  #ffffff;
}

.nav-item a:hover .glyphicons {
  color: #ffffff;
}

#sidebar .nav-link {
  text-align: center;
  padding: 0.75rem 1rem;
}

#sidebar .nav-item {
  height: 45px;
}

.nav-item.active {
  background-color: rgba(0,0,0,.2);
  margin: auto 0;
  
  /*
  border-right: 5px solid rgba(255,255,255,.5);
  border:  1px solid rgba(0,0,0,.45);
  border-radius: .35rem;
  border-bottom-color: rgba(100,100,100,.45);
  border-right-color: rgba(255,255,255,.35);*/
}

#sidebar.active .nav-link {
  text-align: left;
  margin-left: 4px;
}

.btn-logo {
  background-image: url('/images/favicon.png');
  background-color: transparent;
  border: none;
  background-size: 44px 44px;
  background-repeat:  no-repeat;
  transition: background-image 0.25s;
  width: 50px;
  height: 50px;
}

.btn-logo:hover {
  fill: #ffffff;
  color:  #ffffff;
  background-image:  url('/images/logo-expand.png');
  transition: background-image 0.5s;
}

#sidebar.active .btn-logo:hover {
  background-image:  url('/images/logo-collapse.png');
}

#brand_hover {
  height: 55px;
  padding-top: 3px;
  border-bottom:  1px solid rgba(255,255,255,0.25);
  /*background-image: linear-gradient(135deg, #0073cb 0%, #35a2c8 40%, #35a2c8 60%, #0073cb 100%);
  background-size: 100% 55px;*/
}
</style>